import React, { useEffect, useContext } from "react";
import { StoreContext } from "../../Context/StoreContext";
import Carousel from "react-multi-carousel";
import Previous from "../../VibehutUI/Icons/Previous";
import Next from "../../VibehutUI/Icons/Next";
import { useState } from "react";
import { getHomepageRequestEvents } from "../../services/requestEventService";
import RequestEventCard from "./RequestEventCard";
import { InterestedEventcard } from "./InteresteduserCard";
import { InterestedRoomSearchModal } from "./InterestedRoomsearchModal";

function HomeRequestEvents({ sliderWidth }) {
  const { state } = useContext(StoreContext);
  const [events, setEvents] = useState([{ type: "ui" }]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [cardCount, setCardCount] = useState(1);
  const { auth } = state;
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1411 },
      items: 2,
    },
    smalldesktop: {
      breakpoint: { max: 1410, min: 769 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 768, min: 641 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
    },
  };

  const getHomepageRequestEventsFun = async () => {
    await getHomepageRequestEvents(auth?.user?.token)
      .then((res) => {
        setEvents([...events, ...res.data]);
      })
      .catch((err) => {
        setEvents([]);
        console.log("err", err);
      });
  };
  useEffect(() => {
    getHomepageRequestEventsFun();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function splitArrayIntoChunks(chunkSize = 2) {
    const result = [];
    for (let i = 0; i < events.length; i += chunkSize) {
      result.push(events.slice(i, i + chunkSize));
    }
    return result;
  }
  useEffect(() => {
    if (window.innerWidth >= 3000) setCardCount(5);
    else if (window.innerWidth >= 1411) setCardCount(2);
    else if (window.innerWidth > 768) setCardCount(1);
    else setCardCount(2);
  }, []);
  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest;
    return events.length > cardCount ? (
      <div className="absolute right-1 md:top-12 top-8">
        <span className="flex space-x-3">
          <span onClick={() => previous()} className="cursor-pointer">
            <Previous disabled={currentSlide === 0} />
          </span>

          <span onClick={() => next()} className="cursor-pointer">
            <Next />
          </span>
        </span>
      </div>
    ) : (
      <></>
    );
  };
  const chunkEvents = splitArrayIntoChunks();
  return (
    <>
      <div className="relative" style={{ width: sliderWidth }}>
        <div className="pt-8">
          <div className="px-2">
            <p className="font-bold md:text-2xl text-xl text-darkNight dark:text-frescoWhite">
              Interested In Talking
            </p>
            <p className="text-lg text-darkGray">
              Click interested and let Vibehut auto-organize the conversation.
            </p>
          </div>

          <div className="pt-7">
            <div className="hidden md:block w-full">
              <Carousel
                responsive={responsive}
                renderButtonGroupOutside={true}
                itemClass="px-2.5"
                arrows={false}
                shouldResetAutoplay={false}
                customButtonGroup={<ButtonGroup />}
              >
                {events.map((item, columnIndex) => {
                  if (item?.type === "ui") {
                    return (
                      <InterestedEventcard
                        key={columnIndex + item?.type}
                        setIsSearchOpen={setIsSearchOpen}
                      />
                    );
                  }
                  const startDate = new Date(item.startDate);
                  const currentDate = new Date();
                  return (
                    startDate > currentDate &&
                    item.requestedBy.length > 0 && (
                      <div key={columnIndex + item.room._id}>
                        <RequestEventCard
                          event={item}
                          setEvents={setEvents}
                          events={events}
                        />
                      </div>
                    )
                  );
                })}
              </Carousel>
            </div>
            <div className="md:hidden flex flex-col gap-4">
              <Carousel
                responsive={responsive}
                renderButtonGroupOutside={true}
                itemClass="px-2.5"
                arrows={false}
                shouldResetAutoplay={false}
                customButtonGroup={<ButtonGroup />}
              >
                {chunkEvents.map((eventArray, rowIndex) => (
                  <div key={rowIndex} className="flex flex-col gap-4">
                    {eventArray.map((item, columnIndex) => {
                      if (item?.type === "ui") {
                        return (
                          <InterestedEventcard
                            key={columnIndex + item?.type}
                            setIsSearchOpen={setIsSearchOpen}
                          />
                        );
                      }
                      const startDate = new Date(item.startDate);
                      const currentDate = new Date();

                      return (
                        startDate > currentDate &&
                        item.requestedBy.length > 0 && (
                          <div key={columnIndex + item.room._id}>
                            <RequestEventCard
                              event={item}
                              setEvents={setEvents}
                              events={events}
                            />
                          </div>
                        )
                      );
                    })}
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>

      <InterestedRoomSearchModal
        isOpen={isSearchOpen}
        setIsOpen={setIsSearchOpen}
      />
    </>
  );
}

export default HomeRequestEvents;
